import {
  REPORT_START_TIME
} from '@/utils/global.config'
import moment from 'moment'

// localStorage
export const storage = {
  set (key, val) {
    return localStorage.setItem('SF_' + key, JSON.stringify(val))
  },
  get (key) {
    return JSON.parse(localStorage.getItem('SF_' + key))
  },
  remove (key) {
    localStorage.removeItem('SF_' + key)
  }
}

// formData
export const formData = function (obj) {
  let formData = new FormData()
  for (let key in obj) {
    formData.append(key, obj[key])
  }
  return formData()
}

// 判断数组是否有重复元素
export const arrIsRepeat = function (arr) {
  let hash = {}
  for (let i in arr) {
    if (hash[arr[i]]) {
      return true
    }
    hash[arr[i]] = true
  }
  return false
}

// 数据去重
export function arrayWeighting (array) {
  if (!(array instanceof Array)) {
    // eslint-disable-next-line no-throw-literal
    throw 'params must is Array'
  }
  let newArray = []
  array.map(item => {
    if (newArray.length) {
      if (newArray.indexOf(item) === -1) {
        newArray.push(item)
      }
    } else {
      newArray.push(item)
    }
  })
  return newArray
}
/**
 * 判断两个数组是否有交集
 * @export
 * @param {*} arr --用户的权限
 * @param {*} searchArr---路由的权限
 * @returns
 */
export function searchIncludeArr (arr, searchArr) {
  const intersection = arr.filter(v => searchArr.includes(v))
  return intersection.length > 0
}
/**
 * 输出报表的时间范围
 * @returns
 */
export function getDateTimeRange () {
  let flag =
    moment().get('date') > REPORT_START_TIME.date ||
    (moment().get('date') >= REPORT_START_TIME.date &&
      moment().get('hour') >= REPORT_START_TIME.hour)
  // console.log(flag)
  return flag
    ? moment().set({
      date: REPORT_START_TIME.date,
      hour: REPORT_START_TIME.hour,
      minute: 0,
      second: 0
    })
    : moment()
      .month(moment().month() - 1)
      .startOf('month')
      .set({
        date: REPORT_START_TIME.date,
        hour: REPORT_START_TIME.hour,
        minute: 0,
        second: 0
      })
}

// 判断一个对象数组是否存在相同的元素
export function exitSameObj (objArr, key) {
  let newArr = []
  for (let i = 0; i < objArr.length; i++) {
    const element = objArr[i]
    if (newArr.length) {
      let filterArr = newArr.filter(item => {
        return item.id === element.id
      })

      if (filterArr.length) {
        return true
      } else {
        newArr.push(element)
      }

      /* for (let m = 0; m < newArr.length; m++) {
        const item = newArr[m]
        if (element[key] === item[key]) {
          return true
        } else {
          newArr.push(element)
        }
      } */
    } else {
      newArr.push(element)
    }
  }
  return false
}

// 防抖
export function debounce (asyncFun, delay) {
  let timeout = null
  return function () {
    // 获取函数的作用域和参数
    let that = this
    let _args = arguments
    // 如果timeout不为空，则清空计时器，重置计时器
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
      asyncFun.apply(that, _args)
    }, delay)
  }
}
